import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { BsArrowRightShort } from 'react-icons/bs';

import config from '../../config';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import {
  NamedLink,
  LayoutSingleColumn,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  TopbarBlank,
  SectionCustomerLogos,
} from '../../components';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { AuthenticationPage } from '../../containers';
import { manageDisableScrolling } from '../../ducks/UI.duck';

import freelancer1Avatar from '../../assets/signup-page-freelancer-1.webp';
import freelancer2Avatar from '../../assets/signup-page-freelancer-2.webp';
import freelancer3Avatar from '../../assets/signup-page-freelancer-3.webp';

import css from './SignupPage.css';

const SignupPageComponent = props => {
  const { onManageDisableScrolling, scrollingDisabled, intl } = props;
  const [isAuthOpen, setIsAuthOpen] = useState(false);

  const headingPrefix = intl.formatMessage({ id: 'SignupPage.headingPrefix' });
  const headingBrand = intl.formatMessage({ id: 'SignupPage.headingBrand' });
  const subheading = intl.formatMessage({ id: 'SignupPage.subheading' });

  const buyerTitle = intl.formatMessage({ id: 'SignupPage.buyerTitle' });
  const buyerDescription = intl.formatMessage({ id: 'SignupPage.buyerDescription' });

  const freelancerTitle = intl.formatMessage({ id: 'SignupPage.freelancerTitle' });
  const freelancerDescription = intl.formatMessage({ id: 'SignupPage.freelancerDescription' });

  const alreadyHaveAccount = intl.formatMessage({ id: 'SignupPage.alreadyHaveAccount' });
  const login = intl.formatMessage({ id: 'SignupPage.login' });

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'SignupPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'SignupPage.schemaDescription' });

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      description={schemaDescription}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarBlank />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.root}>
            <div className={css.headingGroup}>
              <h2 className={css.heading}>
                {headingPrefix}
                <span className={css.headingHighlight}>{headingBrand}</span>
              </h2>
              <p className={css.subheading}>{subheading}</p>
            </div>

            <div className={css.tilesRow}>
              <NamedLink name="CustomerSignupPage" className={css.tile}>
                <div className={css.tileImageContainer} aria-hidden="true">
                  <div className={css.buyerCardEmpty} />
                  <div className={css.buyerCardBack}>
                    <div className={css.buyerCardRow}>
                      <img src={freelancer2Avatar} className={css.buyerCardAvatarSm} alt="" />
                      <div className={css.buyerCardText}>
                        <p className={css.buyerCardNameSm}>
                          <FormattedMessage id="SignupPage.tileFreelancer2Name" />
                        </p>
                        <p className={css.buyerCardRoleSm}>
                          <FormattedMessage id="SignupPage.tileFreelancer2Role" />
                        </p>
                      </div>
                      <span className={css.buyerHirePillGreen} />
                    </div>
                    <div className={css.buyerCardTags}>
                      <span className={css.buyerTagSm}>
                        <FormattedMessage id="SignupPage.tileTagLocationHelsinki" />
                      </span>
                      <span className={css.buyerTagSm}>
                        <FormattedMessage id="SignupPage.tileTagYearsShort" />
                      </span>
                      <span className={css.buyerTagSm}>
                        <FormattedMessage id="SignupPage.tileTagMarketing" />
                      </span>
                    </div>
                  </div>
                  <div className={css.buyerCardFront}>
                    <div className={css.buyerCardRow}>
                      <img src={freelancer1Avatar} className={css.buyerCardAvatar} alt="" />
                      <div className={css.buyerCardText}>
                        <p className={css.buyerCardName}>
                          <FormattedMessage id="SignupPage.tileFreelancer1Name" />
                        </p>
                        <p className={css.buyerCardRole}>
                          <FormattedMessage id="SignupPage.tileFreelancer1Role" />
                        </p>
                      </div>
                      <span className={css.buyerHirePill}>
                        <FormattedMessage id="SignupPage.tileHireButton" />
                      </span>
                    </div>
                    <div className={css.buyerCardTags}>
                      <span className={css.buyerTag}>
                        <FormattedMessage id="SignupPage.tileTagLocationHelsinki" />
                      </span>
                      <span className={css.buyerTag}>
                        <FormattedMessage id="SignupPage.tileTagMarketing" />
                      </span>
                      <span className={css.buyerTag}>
                        <FormattedMessage id="SignupPage.tileTagYears" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className={css.tileContent}>
                  <div className={css.tileTextGroup}>
                    <h3 className={css.tileTitle}>
                      <span>{buyerTitle}</span>
                      <BsArrowRightShort className={css.tileTitleArrow} />
                    </h3>
                    <p className={css.tileDescription}>{buyerDescription}</p>
                  </div>
                </div>
              </NamedLink>

              <div className={css.tile} onClick={() => setIsAuthOpen(true)}>
                <div className={css.tileImageContainer} aria-hidden="true">
                  <div className={css.sellerCard}>
                    <img src={freelancer3Avatar} className={css.sellerAvatar} alt="" />
                    <p className={css.sellerName}>
                      <FormattedMessage id="SignupPage.tileFreelancer3Name" />
                    </p>
                    <p className={css.sellerRole}>
                      <FormattedMessage id="SignupPage.tileFreelancer3Role" />
                    </p>
                    <div className={css.sellerRating}>
                      <svg
                        className={css.sellerStar}
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.5 0.75l1.964 4.058 4.473.62-3.249 3.114.787 4.43L7.5 10.83l-3.975 2.142.787-4.43L1.063 5.428l4.473-.62L7.5 0.75z"
                          fill="#F5C518"
                        />
                      </svg>
                      <span className={css.sellerRatingScore}>
                        <FormattedMessage id="SignupPage.tileRatingScore" />
                      </span>
                      <span className={css.sellerRatingCount}>
                        <FormattedMessage id="SignupPage.tileRatingCount" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className={css.tileContent}>
                  <div className={css.tileTextGroup}>
                    <h3 className={css.tileTitle}>
                      <span>{freelancerTitle}</span>
                      <BsArrowRightShort className={css.tileTitleArrow} />
                    </h3>
                    <p className={css.tileDescription}>{freelancerDescription}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={css.footer}>
              <div className={css.customerLogos}>
                <SectionCustomerLogos
                  toShow={[
                    'peikko',
                    'olefit',
                    'eerikkila',
                    'corego',
                    'helsinki',
                    'invesdor',
                    'systam',
                    'zervant',
                  ]}
                />
              </div>
              <span className={css.loginRow}>
                {alreadyHaveAccount}{' '}
                <NamedLink name="LoginPage" className={css.loginLink}>
                  {login}
                </NamedLink>
              </span>
            </div>
          </div>

          <AuthenticationPage
            tab="signup"
            isOpen={isAuthOpen}
            onClose={() => setIsAuthOpen(false)}
            onManageDisableScrolling={onManageDisableScrolling}
          />
        </LayoutWrapperMain>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SignupPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(SignupPageComponent);

export default SignupPage;
